/* lab-article-cards.js — turn hand-pasted product CTA blocks into real cards.

   11 of the 15 posts carry an inline upsell that was pasted in as loose
   siblings rather than the [product:handle] shortcode:

     <a href="/products/x"><img src="...bottle.png"></a>
     <h2>Jealousy Terpenes CDT</h2>
     <p>Shop the terps today!</p>
     <a href="/products/x">Shop Now</a>
     <p>Need Bulk? Contact us directly</p>  <a href="tel:..">..</a> <a href="mailto:..">..</a>

   Nothing grouped them, so `.ar-prose img` (max-height 620px) rendered the
   bottle enormous — the reported problem. This regroups each run into the SAME
   .lab-pcard markup the [product:] shortcode emits, so pasted CTAs and
   shortcode CTAs look identical.

   Rules this follows:
     - No text is added, removed or reworded. Nodes are MOVED, not rewritten.
     - The <h2> element itself is moved (not recreated) so its id survives and
       the TOC in lab-article.js — which runs first and has already assigned
       ids — keeps resolving. Scrollspy holds element refs, so it is unaffected.
     - The bulk-contact line is placed AFTER the card, never inside it: the card
       is an <a>, and anchors cannot nest.
   The CSS in lab-article.css caps these images on its own, so a post still
   degrades to something sane if this script never runs. */
(function () {
  'use strict';

  var prose = document.querySelector('.ar-prose.ar-rte');
  if (!prose) return;

  function isBottleLink(a) {
    if (!a || a.tagName !== 'A' || a.classList.contains('lab-pcard')) return false;
    /* The pasted CTAs point at products, collections and pages — the carts post
       links three of its four bottles at /collections/, which is why they were
       left as bare 620px images while the one /products/ link became a card.
       Any same-origin path qualifies; the real guard is the <h2> requirement
       below, which is what distinguishes a CTA block from an inline figure. */
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '/' || href.charAt(1) === '/') return false;
    // the anchor must wrap an image and nothing else
    return a.children.length === 1 && a.children[0].tagName === 'IMG' && !a.textContent.trim();
  }

  /* the top-level block in the reading column that contains this node */
  function blockOf(node) {
    while (node && node.parentNode !== prose) node = node.parentNode;
    return node;
  }

  function hasBottleLink(el) {
    if (!el || el.nodeType !== 1) return false;
    if (isBottleLink(el)) return true;
    return [].slice.call(el.querySelectorAll('a')).some(isBottleLink);
  }

  var svg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
            'stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  [].slice.call(prose.querySelectorAll('a')).forEach(function (anchor) {
    if (!isBottleLink(anchor)) return;

    var start = blockOf(anchor);
    if (!start || start.dataset.arCard) return;

    /* Walk forward collecting the rest of the CTA run. Stop at the next
       heading, or at the next pasted bottle — one post starts its next CTA
       before any heading, and without that guard we would swallow it. */
    var run = [], node = start.nextElementSibling, title = null;
    while (node) {
      var isHeading = /^H[23]$/.test(node.tagName) || node.querySelector('h2, h3');
      if (isHeading && !title) {
        title = node.tagName === 'H2' || node.tagName === 'H3' ? node : node.querySelector('h2, h3');
        run.push(node);
        node = node.nextElementSibling;
        continue;
      }
      if (isHeading || hasBottleLink(node)) break;
      run.push(node);
      node = node.nextElementSibling;
    }
    if (!title) return;              // no title -> not the CTA pattern, leave alone

    var href = anchor.getAttribute('href');
    var img = anchor.children[0];

    /* Split the tail: the "Shop Now" link is replaced by the card's own button;
       everything else (bulk contact, phone, email) is kept verbatim below. */
    var tail = document.createElement('p');
    tail.className = 'ar-pcard-bulk';
    var snippet = null;

    run.forEach(function (el) {
      if (el === title || el.contains(title)) return;
      // The pasted "Shop Now" link duplicates the card's own button. Drop it —
      // and stop, or its text would still be harvested into the tail below.
      if (el.tagName === 'A' && (el.getAttribute('href') || '') === href) return;
      [].slice.call(el.querySelectorAll('a')).forEach(function (a) {
        if ((a.getAttribute('href') || '') === href) a.remove();
      });
      if (!el.textContent.trim() && !el.querySelector('a')) return; // leftover <br>/empty
      if (!snippet && el.tagName === 'P' && !el.querySelector('a')) { snippet = el; return; }
      while (el.firstChild) tail.appendChild(el.firstChild);
      tail.appendChild(document.createTextNode(' '));
    });

    var card = document.createElement('a');
    card.className = 'lab-pcard ar-pcard ar-pcard--auto';
    card.href = href;

    var imgwrap = document.createElement('div');
    imgwrap.className = 'lab-pcard__imgwrap';
    imgwrap.appendChild(img);

    var info = document.createElement('div');
    info.className = 'ar-pcard-info';

    var eyebrow = document.createElement('div');
    eyebrow.className = 'lab-pcard__tag';
    eyebrow.innerHTML = 'The All-Natural Choice<span class="ar-tm">&trade;</span>';

    title.classList.add('lab-pcard__name');
    var rule = document.createElement('div');
    rule.className = 'lab-pcard__rule';

    info.appendChild(eyebrow);
    info.appendChild(title);
    info.appendChild(rule);
    if (snippet) { snippet.classList.add('ar-pcard-note'); info.appendChild(snippet); }

    var btn = document.createElement('span');
    btn.className = 'ar-btn-gold ar-pcard-btn';
    btn.innerHTML = 'Shop now ' + svg;
    info.appendChild(btn);

    card.appendChild(imgwrap);
    card.appendChild(info);
    card.dataset.arCard = '1';

    start.parentNode.insertBefore(card, start);
    if (tail.textContent.trim()) card.parentNode.insertBefore(tail, card.nextSibling);

    /* Drop the now-empty originals — but never anything that was MOVED into
       the card. The title and the snippet are members of `run` and now live
       inside .ar-pcard-info, so removing them by list membership deleted the
       card's own name and note. */
    run.concat([start]).forEach(function (el) {
      if (!el || !el.parentNode) return;
      if (card.contains(el) || tail.contains(el)) return;
      el.parentNode.removeChild(el);
    });
  });
})();
